import { Fragment } from "react";

import { Menu, Transition } from "@headlessui/react";
import CheckIcon from "../assets/icons/CheckIcon";

const PopUp = ({
  activeOption,
  options,
  children,
  menuItemsClassName = "",
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button>{children}</Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`absolute right-0 z-10 mt-2  origin-top-left rounded-md bg-zinc-800 text-white shadow-lg ring-1 ring-zinc-700 focus:outline-none ${menuItemsClassName}`}
        >
          <div className="py-1">
            {options?.map((option) => {
              return (
                <Menu.Item key={option.title}>
                  <button
                    className={`relative w-full block px-4 ${
                      activeOption ? "pl-8" : ""
                    } py-2 text-sm text-left hover:bg-zinc-700 ${
                      option.className
                    } ${activeOption === option.title ? "bg-zinc-700" : ""}`}
                    onClick={(event) =>
                      option.onClick({ event, title: option.title })
                    }
                  >
                    {activeOption === option.title ? (
                      <CheckIcon className="absolute top-2.5 left-2 w-4 h-4" />
                    ) : null}
                    <span>{option?.title}</span>
                  </button>
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default PopUp;
